var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.COLLECTION_FRAGMENT = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const imageFragment_1 = require("./imageFragment");
exports.COLLECTION_FRAGMENT = (0, graphql_tag_1.default) `
  fragment CollectionFragment on Collection {
    id
    title
    handle
    description
    descriptionHtml
    image {
      ...ImageFragment
    }
  }
  ${imageFragment_1.IMAGE_FRAGMENT}
`;
//# sourceMappingURL=collectionFragment.js.map